<iframe
  [src]="iframeUrl"
  [title]="getFrameTitle()"
  id="graphing-iframe"
  [class.is-locked]="isLocked"
  [attr.tabindex]="isLocked ? -1 : null"
  [attr.aria-disabled]="isLocked ? 'true' : null"
  [attr.inert]="isLocked ? '' : null"
  style="width: 508px; height: 608px;"
  (load)="handleFrameLoad()"
 data-ui-name="Iframe" data-ui-component="element-render-graphing" data-testid="element-render-graphing-iframe"></iframe>
<p class="sr-only" role="status" aria-live="polite" data-ui-name="Status Message" data-ui-component="element-render-graphing" data-testid="element-render-graphing-status-message">{{ statusMessage }}</p>
